import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from 'src/models/users/users';
import { environment } from 'src/environments/environment.prod';

const SERVICE_NAME =  environment.SERVICE_NAME;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  constructor(private http: HttpClient) {
  }


  checkUser(login?: User): Observable<User> {
    // let opPassword = this.encryptionOf(login.password);
    // login = { email: login.email, password: opPassword };
    // return this.http.post<any>(SERVICE_NAME + 'login', login);
    return this.http.post<User>(SERVICE_NAME + 'login', login, httpOptions);
  }

  refreshToken(token: string, HTTP_HEADERS) {
    return this.http.post(SERVICE_NAME + 'refreshtoken', {refreshToken: token}, HTTP_HEADERS);

  }

}